import { SvgIcon, SvgIconProps } from "@mui/material";

export const AiHomeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <g clip-path="url(#ai-home-icon-clip)">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="1.2"
          d="M13.842 3.632a3 3 0 0 0-3.684 0l-6 4.667A3 3 0 0 0 3 10.667V18a3 3 0 0 0 3 3h2.6a1 1 0 0 0 1-1v-4.1a1.5 1.5 0 0 1 1.5-1.5h1.8a1.5 1.5 0 0 1 1.5 1.5V20a1 1 0 0 0 1 1H18a3 3 0 0 0 3-3v-6.5"
        />
        <path
          stroke="currentColor"
          stroke-width="1.2"
          d="M15.951 6.326a.627.627 0 0 1 1.1 0l.487.888a.63.63 0 0 0 .25.25l.888.486a.627.627 0 0 1 0 1.1l-.888.487a.6.6 0 0 0-.25.25l-.486.887a.627.627 0 0 1-1.1 0l-.487-.888a.6.6 0 0 0-.25-.25l-.888-.485a.627.627 0 0 1 0-1.101l.888-.486a.63.63 0 0 0 .25-.25z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="ai-home-icon-clip">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
